import React from 'react';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import {
  LoadingStatus,
  SubmittingStatus,
} from '../../../../../shared/infrastructure/types/common/common-types';
import { useUILogic } from '../../../shared/providers/UILogicProvider/hooks';
import { useMask } from '../../../../../shared/ui/hooks/useMask';
import { maskingHandlers } from '../../../../../shared/infrastructure/masking-helpers/masking-handlers';
import UiKit from '../../../../../shared/ui/ui-kit';

let ChangePhoneForm = function () {
  const { t } = useTranslation();
  const { authorizationUiModule } = useUILogic();
  const registerUIManager = authorizationUiModule.registerUIManager;
  const { value, onChangeMaskedValue } = useMask({
    defaultValue: registerUIManager.coreManager.phone,
    maskHandler: value => maskingHandlers.phoneNumberMask({ value }),
    onAccept: (maskedValue, unmaskedValue) => {
      registerUIManager.coreManager.setPhone(unmaskedValue);
    },
  });

  return (
    <Wrapper>
      <UiKit.form.Item.VerticalLayoutTemplate label={t('register.label.phone')}>
        <UiKit.form.Validation
          validateStatus={registerUIManager.coreManager.validator.phone.isValid ? '' : 'error'}
          message={t(registerUIManager.coreManager.validator.phone.errors[0]) as string}
          turnValidation={
            registerUIManager.coreManager.formStatus === SubmittingStatus.ERROR_SUBMITTING
          }
        >
          <UiKit.Input
            value={value}
            placeholder={'+7 912 000-00-00'}
            onChange={value => onChangeMaskedValue(value)}
          />
        </UiKit.form.Validation>
      </UiKit.form.Item.VerticalLayoutTemplate>

      <UiKit.Button
        onClick={() => registerUIManager.coreManager.confirmationNewPhone()}
        customStyles={{ width: '100%' }}
        type={'primary'}
      >
        {t('register.continue.button')}
      </UiKit.Button>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 40px;
`;

ChangePhoneForm = observer(ChangePhoneForm);

export { ChangePhoneForm };
